import { call, put, takeLatest } from 'redux-saga/effects';
import {
    FETCH_LOCALITIES_REQUEST,
    fetchLocalitiesSuccess,
    fetchLocalitiesFailure
} from '../actions/localityActions';
import { adminAPI } from '../../utils/axiosInstance';

const mapLocalityResponse = (responseData = {}) => {
    const localities = Array.isArray(responseData.localities)
        ? responseData.localities.map((loc) =>
              typeof loc === 'string' ? loc : loc?.locality,
          ).filter(Boolean)
        : [];

    return {
        localities,
        district: responseData.district || '',
        state: responseData.state || '',
    };
};

function* fetchLocalitiesSaga(action) {
    try {
        const response = yield call([adminAPI, 'get'], `/locality/${action.payload}`);
        yield put(fetchLocalitiesSuccess(mapLocalityResponse(response.data?.data)));
    } catch (error) {
        if (error?.response?.data?.message === "Locality does not exist") {
            try {
                const postResponse = yield call([adminAPI, 'post'], `/locality/${action.payload}`);
                yield put(fetchLocalitiesSuccess(mapLocalityResponse(postResponse.data?.data)));
            } catch (postError) {
                yield put(fetchLocalitiesFailure(postError?.response?.data?.message || "Failed to fetch localities"));
                console.log(postError?.response?.data?.message);
            }
        } else {
            yield put(fetchLocalitiesFailure(error?.response?.data?.message || "Failed to fetch localities"));
            console.log(error?.response?.data?.message);
        }
    }
}

function* watchFetchLocalities() {
    yield takeLatest(FETCH_LOCALITIES_REQUEST, fetchLocalitiesSaga);
}

export default watchFetchLocalities;
